import React from 'react';

import type { tpCity } from 'src/components/main/quiz/hometown-step/components/search-results';

import styles from './search-item.module.scss';

export const SearchItem = ({
  city,
  onClick,
}: {
  city: tpCity;
  onClick: () => void;
}) => (
  <li className={styles.city} onClick={onClick}>
    {city.properties.name},&nbsp;
    {city.properties.state ? city.properties.state + ', ' : null}
    {city.properties.country}
  </li>
);
